// @flow
import React from 'react'
import Immutable from 'seamless-immutable'

// components
import { FieldLabel } from '../../Components/'
import { Bool } from '../../Components/_formFields'

// types
import type { DefaultMiniAppProps } from './'

type CicEnableAppProps = DefaultMiniAppProps & {
  miniAppData: {
    cicEnableAppTextMode?: boolean,
    onlyTpl?: boolean,
  }
}

// TODO pure component?
export default class CicEnableApp extends React.Component<CicEnableAppProps> {
  static defaultProps = {
    isBackOffice: false,
  }

  componentDidMount() {
    const { formData, miniAppData, onChangeFieldVisibility } = this.props
    const value = formData && formData.cicEnabled
    if (value && !formData.cic) {
      this.handleOnChange(value)
    } else if (!value && formData.cic) {
      this.handleOnChange(value)
    }
    if (miniAppData && (miniAppData.cicEnableAppTextMode && miniAppData.onlyTpl || !value)) {
      onChangeFieldVisibility('cic', true)
    } else {
      onChangeFieldVisibility('cic', false)
    }
  }

  componentDidUpdate(prevProps: CicEnableAppProps) {
    if (this.props.formData.getIn(['cicEnabled']) !== prevProps.formData.getIn(['cicEnabled'])) {
      this.props.onChangeFieldVisibility('cic', !this.props.formData.getIn(['cicEnabled']))
    }
  }

  handleOnChange = (value: boolean) => {
    const { formData, onChangeFormData, onChangeFieldVisibility } = this.props
    let changedFormData = new Immutable({ cicEnabled: value })
    if (value) {
      if (!Object.keys(formData.getIn(['cic'], {})).length) {
        changedFormData = changedFormData.set('cic', {
          coveredArea: 'europe',
          immobiliser: true,
          priceExcludesVAT: false,
        })
      }
      onChangeFormData(changedFormData, ['cic'])
    } else {
      changedFormData = changedFormData.set('cic', undefined)
      // delete changedFormData.cic
      onChangeFormData(changedFormData, ['cic'])
    }
    onChangeFieldVisibility('cic', !value)
  }

  render() {
    const { formData, content, miniAppData } = this.props

    if (miniAppData && miniAppData.cicEnableAppTextMode) {
      return null
    }

    return ([
      <div className='form-group d-flex flex-row flex-wrap flex-sm-row align-items-center' key='CicEnableApp-content'>
        <div className='col-10 col-sm-4 order-0 order-sm-0 pt-sm-2 mt-sm-1 text-sm-right'>
          <FieldLabel
            id='CicEnableApp'
            label={content.fieldNames.cicEnabled}
          />
        </div>
        <div className='col-12 col-sm-6 order-3 order-sm-0 my-2'>
          <Bool
            enabled
            id='CicEnableApp'
            isPristine
            label={content.fieldNames.cicEnabledLabel}
            name='cicEnabled'
            onChange={(value) => {
              this.handleOnChange(value)
            }}
            prefix='cic-'
            validationErrors={{}}
            value={formData && formData.cicEnabled}
          />
        </div>
      </div>
    ])
  }
}
